import Vue from 'vue';

const success = (context, isFromUserAccount) => {
  if (!isFromUserAccount) {
    toastr.success('Account is unlocked successfully');
  } else {
    context.closeSyncModal();
  }
};

const failed = (context, error) => {
  context.showToasterError(error);
};

export default (context, email, isFromUserAccount = false) => Vue.$http.get(`/unlock-user/${email}`)
  .then((response) => {
    if (response && response.status === 200) {
      success(context, isFromUserAccount);
    }
  })
  .catch((error) => {
    failed(context, error);
  });



// WEBPACK FOOTER //
// ./src/app/services/account/unLockUser.js